import api from '@/config/api'
import type { ApiResponse } from '@/shared/types/api'
import type { EvenementEtudiantDTO, CreateEvenementRequest, MatiereSimpleDTO, VacancesPeriode } from '@/shared/types/evenement'

export const eventsApi = {
  getByEtudiantId: (etudiantId: number) =>
    api.get<ApiResponse<EvenementEtudiantDTO[]>>(`/api/evenements/etudiant/${etudiantId}`).then((r) => r.data.data),

  getMyEvents: () =>
    api.get<ApiResponse<EvenementEtudiantDTO[]>>('/api/evenements/me').then((r) => r.data.data),

  create: (data: CreateEvenementRequest) =>
    api.post<ApiResponse<EvenementEtudiantDTO>>('/api/evenements', data).then((r) => r.data.data),

  update: (id: number, data: CreateEvenementRequest) =>
    api.put<ApiResponse<EvenementEtudiantDTO>>(`/api/evenements/${id}`, data).then((r) => r.data.data),

  delete: (id: number) =>
    api.delete<ApiResponse<void>>(`/api/evenements/${id}`).then((r) => r.data),

  getMyMatieres: () =>
    api.get<ApiResponse<MatiereSimpleDTO[]>>('/api/evenements/me/matieres').then((r) => r.data.data),

  getMyVacancesPeriodes: () =>
    api.get<ApiResponse<VacancesPeriode[]>>('/api/evenements/me/vacances-periodes').then((r) => r.data.data),

  getMyPeriodesExclues: () =>
    api.get<ApiResponse<VacancesPeriode[]>>('/api/evenements/me/periodes-exclues').then((r) => r.data.data),
}
